import '../../models/add-to-cart/add-to-cart.js';
import { LoyaltyCardType } from '../../models/cart/cart.js';
import '../../models/checkoutState/checkoutState.js';
import '@swc/helpers';
import '../../utils/cart-count-var.js';
import '../../utils/cart-id-var.js';
import { getActiveVoucherCodes, getActiveVoucherNames } from '../../utils/get-active-voucher-codes.js';
import { getAddress } from '../../utils/get-address.js';
import '@grandvisionhq/utils';
import { getCartPrices } from '../../utils/get-cart-prices.js';
import { getCustomerDetails } from '../../utils/get-customer-details.js';
import '@grandvisionhq/commercetools';
import '@grandvisionhq/graphql';
import { getShippingMethod } from '../../utils/get-shipping-method.js';
import '../../utils/get-unrecoverable-validation-errors.js';
import { lineItemDataMapper } from '../../utils/line-item-data-mapper.js';
import { createContainsHelper } from '../../utils/create-contains-helper.js';
import '../../utils/get-failure-error-codes.js';
import { mapAppliedCartDiscounts } from '../../utils/map-applied-cart-discounts.js';
import { getValidationErrorsByLineItem } from '../../utils/get-validation-errors-by-line-item.js';
import { toVisualLineItem } from './visual-line-item/cart-line-item.js';

const toCartView = (cart, validationErrors, settings, intl, apiUrl)=>{
    const lineItemsRaw = cart.lineItems;
    const lineItems = lineItemDataMapper(lineItemsRaw, settings, intl);
    const visualLineItems = lineItemsRaw.map((lineItemRaw)=>toVisualLineItem(lineItemRaw, intl, settings, apiUrl)
    ).filter((lineItem)=>Boolean(lineItem)
    );
    return {
        id: cart.id,
        numberOfItems: cart.numberOfItems,
        hasDistinctDeliveryEstimations: cart.hasDistinctDeliveryEstimations,
        lineItems,
        visualLineItems,
        hasSubscription: cart.hasSubscription,
        validationErrors: getValidationErrorsByLineItem(validationErrors),
        additionalCartCostLineItems: cart.additionalCartCostLineItems,
        prices: getCartPrices(cart.price, cart.shippingMethod),
        voucherCodes: getActiveVoucherCodes(cart.vouchers),
        voucherNames: getActiveVoucherNames(cart.vouchers),
        isAccountRequired: !!cart.isAccountRequired,
        billingAddress: getAddress(cart.billingAddress),
        shippingAddress: getAddress(cart.shippingAddress),
        shippingMethod: getShippingMethod(cart.shippingMethod),
        customerDetails: getCustomerDetails(cart.customerDetails),
        checkoutState: cart.checkoutState,
        serviceStore: cart.serviceStore ? {
            globalStoreId: cart.serviceStore.globalStoreId
        } : undefined,
        loyaltyDetails: {
            cardNumber: cart.loyaltyDetails.cardNumber || null,
            points: cart.loyaltyDetails.points,
            type: cart.loyaltyDetails.cardNumberType ? LoyaltyCardType[cart.loyaltyDetails.cardNumberType] : null
        },
        contains: createContainsHelper(lineItems),
        appliedCartDiscounts: mapAppliedCartDiscounts(cart === null || cart === void 0 ? void 0 : cart.cartAppliedDiscounts, intl.locale),
        hasAlternativeShippingState: cart.hasAlternativeShippingState
    };
};

export { toCartView };
//# sourceMappingURL=to-cart-view.js.map
